import React, { useState } from 'react';

import {
  Container,
  Typography,
  Grid
} from '@material-ui/core';

import {
  BooleanField,
  TextField,
  Select,
  MultiSelect,
  OutlinedTextField,
  OutlinedTextArea,
  Editor
} from './common/fields';

const selectOptions = [
  {label: 'Option 1', value: 1},
  {label: 'Option 2', value: 2},
  {label: 'Option 3', value: 3},
]

const Tooltip = () => {
  return (
    <>
      <Typography variant="overline">Tooltip title</Typography>
      <Typography variant="subtitle1" component="div">Tooltip content</Typography>
    </>
  );
};

const StyleGuide = () => {
  const [ state, setState ] = useState({
    bool: '0',
    single: '',
    multi: [],
    text: '',
    outlinedText: '',
    outlinedTextTooltip: '',
    outlinedTextCounter: '',
    outlinedTextArea: '',
    editor: '<b>Some bold text</b>'
  });

  const onFieldChange = event => {
    setState({
      ...state,
      [event.target.name]: event.target.value
    })
  }


  return (
    <Container>
      <Typography variant="h1">Style guide</Typography>

      <Typography variant="h2">Form fields</Typography>
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <BooleanField
            label="Boolean field"
            name="bool"
            value={state.bool}
            onChange={onFieldChange}
            helperText="Optional helper text"
          />
        </Grid>
        <Grid item xs={6}>
          <BooleanField
            label="Boolean field (disabled)"
            name="bool"
            value={state.bool}
            onChange={onFieldChange}
            disabled
          />
        </Grid>

        <Grid item xs={6}>
          <Select
            label="Single select"
            options={selectOptions}
            name="single"
            value={state.single || ''}
            onChange={onFieldChange}
            helperText="Optional helper text"
          />
        </Grid>
        <Grid item xs={6}>
          <Select
            label="Single select (disabled)"
            options={selectOptions}
            name="single"
            value={state.single}
            onChange={onFieldChange}
            disabled
          />
        </Grid>

        <Grid item xs={6}>
          <Select
            label="Single select (filled variant)"
            customLabel={false}
            variant="filled"
            options={selectOptions}
            name="single"
            value={state.single}
            onChange={onFieldChange}
          />
        </Grid>
        <Grid item xs={6}>
          <Select
            label="Single select (filled variant, disabled)"
            customLabel={false}
            variant="filled"
            options={selectOptions}
            value={state.single}
            onChange={onFieldChange}
            disabled
          />
        </Grid>

        <Grid item xs={6}>
          <MultiSelect
            label="Multiselect"
            options={selectOptions}
            name="multi"
            value={state.multi}
            onChange={onFieldChange}
            helperText="Optional helper text"
          />
        </Grid>
        <Grid item xs={6}>
          <MultiSelect
            label="Multiselect (disabled)"
            options={selectOptions}
            name="multi"
            value={state.multi}
            onChange={onFieldChange}
            disabled
          />
        </Grid>

        <Grid item xs={6}>
          <MultiSelect
            label="Multiselect with search"
            options={selectOptions}
            name="multi"
            value={state.multi}
            onChange={onFieldChange}
            search
          />
        </Grid>
        <Grid item xs={6}>
          <MultiSelect
            label="Multiselect with search (disabled)"
            options={selectOptions}
            name="multi"
            value={state.multi}
            onChange={onFieldChange}
            search
            disabled
          />
        </Grid>

        <Grid item xs={6}>
          <MultiSelect
            label="Multiselect (filled variant)"
            customLabel={false}
            variant="filled"
            options={selectOptions}
            name="multi"
            value={state.multi}
            onChange={onFieldChange}
          />
        </Grid>
        <Grid item xs={6}>
          <MultiSelect
            label="Multiselect (filled variant, disabled)"
            customLabel={false}
            variant="filled"
            options={selectOptions}
            name="multi"
            value={state.multi}
            onChange={onFieldChange}
            disabled
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            label="Text"
            name="text"
            value={state.text}
            onChange={onFieldChange}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            label="Text (disabled)"
            name="text"
            value={state.text}
            onChange={onFieldChange}
            disabled
          />
        </Grid>

        <Grid item xs={6}>
          <OutlinedTextField
            label="Outlined text"
            name="outlinedText"
            value={state.outlinedText}
            onChange={onFieldChange}
          />
        </Grid>
        <Grid item xs={6}>
          <OutlinedTextField
            label="Outlined text (disabled)"
            name="outlinedText"
            value={state.outlinedText}
            onChange={onFieldChange}
            disabled
          />
        </Grid>

        <Grid item xs={6}>
          <OutlinedTextField
            label="Outlined text with tooltip"
            name="outlinedTextTooltip"
            value={state.outlinedTextTooltip}
            onChange={onFieldChange}
            tooltip={<Tooltip />}
          />
        </Grid>
        <Grid item xs={6}>
          <OutlinedTextField
            label="Outlined text with tooltip (disabled)"
            name="outlinedTextTooltip"
            value={state.outlinedTextTooltip}
            onChange={onFieldChange}
            tooltip={<Tooltip />}
            disabled
          />
        </Grid>

        <Grid item xs={6}>
          <OutlinedTextField
            label="Outlined text with counter"
            name="outlinedTextCounter"
            value={state.outlinedTextCounter}
            onChange={onFieldChange}
            maxLength={50}
          />
        </Grid>
        <Grid item xs={6}>
          <OutlinedTextField
            label="Outlined text with counter (disabled)"
            name="outlinedTextCounter"
            value={state.outlinedTextCounter}
            onChange={onFieldChange}
            maxLength={50}
            disabled
          />
        </Grid>

        <Grid item xs={6}>
          <OutlinedTextField
            label="Outlined text with counter and helper text"
            name="outlinedTextCounter"
            value={state.outlinedTextCounter}
            onChange={onFieldChange}
            maxLength={50}
            helperText="A helpful hint"
          />
        </Grid>
        <Grid item xs={6}>
          <OutlinedTextField
            label="Outlined text with counter and helper text (disabled)"
            name="outlinedTextCounter"
            value={state.outlinedTextCounter}
            onChange={onFieldChange}
            maxLength={50}
            helperText="A helpful hint"
            disabled
          />
        </Grid>

        <Grid item xs={6}>
          <OutlinedTextArea
            label="Outlined textarea"
            name="outlinedTextArea"
            value={state.outlinedTextArea}
            onChange={onFieldChange}
            maxLength={50}
            helperText="A helpful hint"
          />
        </Grid>
        <Grid item xs={6}>
          <OutlinedTextArea
            label="Outlined textarea"
            name="outlinedTextArea"
            value={state.outlinedTextArea}
            onChange={onFieldChange}
            maxLength={50}
            helperText="A helpful hint"
            disabled
          />
        </Grid>

        <Grid item xs={6}>
          <Editor
            label="Editor"
            name="editor"
            value={state.editor}
            onChange={onFieldChange}
            maxLength={80}
            helperText="Max length does not force limits.."
          />
        </Grid>

        <Grid item xs={6}>
          <Editor
            label="Editor"
            name="editor"
            value={state.editor}
            onChange={onFieldChange}
            maxLength={80}
            disabled
          />
        </Grid>
      </Grid>

    </Container>
  );
}

export default StyleGuide;
